import { Modal, Button, Input, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// Yup schema
const schema = yup.object({
  reason: yup.string().trim().required('Reason is required'),
});

const RejectButton = ({ record, handleReject }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      reason: '',
    },
  });

  const onSubmit = (data) => {
    handleReject(record.id, data.reason.trim());
    reset();
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip title="Reject Media">
        <Button
          size="small"
          danger
          icon={<CloseOutlined />}
          onClick={() => setIsModalOpen(true)}
        />
      </Tooltip>

      <Modal
        title="Reject Media"
        open={isModalOpen}
        onOk={handleSubmit(onSubmit)}
        onCancel={() => {
          reset();
          setIsModalOpen(false);
        }}
        okText="Reject"
        cancelText="Cancel"
      >
        <label style={{ fontWeight: 500 }}>Reason</label>
        <Controller
          name="reason"
          control={control}
          render={({ field }) => (
            <Input.TextArea
              rows={4}
              placeholder="Enter rejection reason"
              {...field}
            />
          )}
        />
        {errors.reason && (
          <div style={{ color: 'red', marginTop: 4 }}>{errors.reason.message}</div>
        )}
      </Modal>
    </>
  );
};

export default RejectButton;
